// (c) chaehongee. Confidential and proprietary.

import { createContext, useContext, type ReactElement } from 'react'
import { useStackNavigator } from './useStackNavigator'
import type { BackstageRoute } from './navigationConfig'

type RouteName = BackstageRoute

export interface BackstageNavigator {
    current: RouteName
    canGoBack: boolean
    push: (name: RouteName) => void
    replace: (name: RouteName) => void
    goBack: () => void
}

const Ctx = createContext<BackstageNavigator | null>(null)

export function BackstageNavigatorProvider({ initial, children }: { initial: RouteName; children: ReactElement }): ReactElement {
    const nav = useStackNavigator<RouteName>(initial)
    const api: BackstageNavigator = {
        current: nav.current,
        canGoBack: nav.canGoBack,
        push: nav.push,
        replace: nav.replace,
        goBack: nav.goBack,
    }
    return <Ctx.Provider value={api}>{children}</Ctx.Provider>
}

export function useBackstageNav(): BackstageNavigator {
    const ctx = useContext(Ctx)
    if (!ctx) {
        throw new Error('useBackstageNav must be used within BackstageNavigatorProvider')
    }
    return ctx
}

export function BackstageRoutes({ routes, fallback }: { routes: Array<{ name: RouteName; element: ReactElement }>; fallback?: ReactElement }): ReactElement {
    const { current } = useBackstageNav()
    const route = routes.find((r) => r.name === current)
    return route ? route.element : (fallback ?? routes[0]?.element ?? <></>)
}


